/* unplugin-vue-components disabled */import __unplugin_components_0 from '/var/lib/jenkins/workspace/mainnet-unipass-wallet-frontend/src/components/up-icon.vue';
import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "token-box"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  key: 0,
  class: "index"
};
const _hoisted_4 = {
  class: "index-title"
};
const _hoisted_5 = {
  key: 1,
  class: "overage"
};
const _hoisted_6 = {
  class: "token-name"
};
const _hoisted_7 = {
  class: "token-overage"
};
const _hoisted_8 = {
  key: 2,
  class: "name"
};
import { getChainName } from '@/service/chains-config';
import { formatBalance, formatAddress } from '@/utils/useUniPass';
export default /*#__PURE__*/_defineComponent({
  __name: 'up-token',
  props: {
    name: {
      default: ''
    },
    symbol: {
      default: ''
    },
    chain: {
      default: 'polygon'
    },
    contractAddress: null,
    balance: {
      default: undefined
    },
    type: null,
    icon: null,
    subtitle: null,
    subtitleFontSize: {
      default: ''
    }
  },

  setup(__props) {
    const props = __props;
    const chainName = computed(() => {
      return getChainName(props.chain);
    });
    const subtitleDefault = computed(() => {
      const dict = {
        MATIC: 'MATIC',
        WETH: 'Ethereum',
        USDT: 'Tether',
        USDC: 'USD Coin'
      };
      return dict[props.symbol] || props.name;
    });
    const noError = ref(false);
    return (_ctx, _cache) => {
      const _component_up_icon = __unplugin_components_0;

      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["up-token", __props.type])
      }, [_createElementVNode("div", _hoisted_1, [props.icon && !noError.value ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        class: "box-icon",
        src: props.icon,
        onError: _cache[0] || (_cache[0] = $event => noError.value = true),
        alt: "icon"
      }, null, 40, _hoisted_2)) : (_openBlock(), _createBlock(_component_up_icon, {
        key: 1,
        class: "box-token",
        name: props.symbol,
        type: "coin"
      }, null, 8, ["name"])), _createVNode(_component_up_icon, {
        class: "box-chain",
        name: _unref(chainName)
      }, null, 8, ["name"])]), props.type === 'index' ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, _toDisplayString(props.symbol), 1), _createElementVNode("div", {
        class: "index-subtitle",
        style: _normalizeStyle({
          fontSize: props.subtitleFontSize
        })
      }, _toDisplayString(props.subtitle || _unref(subtitleDefault)), 5), props.contractAddress ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "index-subtitle",
        style: _normalizeStyle({
          fontSize: props.subtitleFontSize
        })
      }, _toDisplayString(_unref(formatAddress)(props.contractAddress)), 5)) : _createCommentVNode("", true)])) : props.balance !== undefined ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, _toDisplayString(props.symbol), 1), _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('Balance')) + ": " + _toDisplayString(_unref(formatBalance)(props.balance)), 1)])) : (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(props.symbol), 1))], 2);
    };
  }

});